import gaParams from '../../../utilities/analytics/constants';
import {gaEvent} from '../../../utilities/analytics/tracking';

export function gaReportShownPage(page) {
  gaEvent(gaParams.UPDATE_PAYMENT_METHOD_SHOW.category, gaParams.UPDATE_PAYMENT_METHOD_SHOW.eventType, page);
}

export function gaReportSelectedOrgId(length) {
  gaEvent(gaParams.UPDATE_PAYMENT_METHOD_SHOW_CHOOSE_ORGID.category, gaParams.UPDATE_PAYMENT_METHOD_SHOW_CHOOSE_ORGID.eventType, length);
}

export function gaShowCompanyType() {
  gaEvent(
    gaParams.UPDATE_PAYMENT_METHOD_SHOW_COMPANYTYPE.category,
    gaParams.UPDATE_PAYMENT_METHOD_SHOW_COMPANYTYPE.eventType,
    gaParams.UPDATE_PAYMENT_METHOD_SHOW_COMPANYTYPE.eventParams
  );
}
export function gaReportOnButtonClick(buttonName) {
  gaEvent(gaParams.UPDATE_PAYMENT_METHOD_CLICK_BUTTON.category, gaParams.UPDATE_PAYMENT_METHOD_CLICK_BUTTON.eventType, buttonName);
}

export function gaReportOnClickUpdateBtnPrivate() {
  gaEvent(
    gaParams.UPDATE_PRIVATE_PAYMENT_CLICK_UPDATE_BTN.category,
    gaParams.UPDATE_PRIVATE_PAYMENT_CLICK_UPDATE_BTN.eventType,
    gaParams.UPDATE_PRIVATE_PAYMENT_CLICK_UPDATE_BTN.eventParams
  );
}
export function gaReportOnClickForwardWithUpdatePrivate() {
  gaEvent(
    gaParams.UPDATE_PRIVATE_PAYMENT_CLICK_FORWARD_WITH_UPDATE.category,
    gaParams.UPDATE_PRIVATE_PAYMENT_CLICK_FORWARD_WITH_UPDATE.eventType,
    gaParams.UPDATE_PRIVATE_PAYMENT_CLICK_FORWARD_WITH_UPDATE.eventParams
  );
}

export function gaShowNumOfMethods(length) {
  gaEvent(
    gaParams.UPDATE_PAYMENT_METHOD_SHOW_NUM_OF_METHOD_OPTIONS.category,
    gaParams.UPDATE_PAYMENT_METHOD_SHOW_NUM_OF_METHOD_OPTIONS.eventType,
    length
  );
}

export function gaShowNumOfMethodsPrivate(length) {
  gaEvent(
    gaParams.UPDATE_PRIVATE_PAYMENT_SHOW_STARTING_PAGE.category,
    gaParams.UPDATE_PRIVATE_PAYMENT_SHOW_STARTING_PAGE.eventType,
    length
  );
}

export function gaShowNumOfOrgNoPayment(msg) {
  gaEvent(
    gaParams.UPDATE_PAYMENT_METHOD_SHOW_NUM_OF_ORGS_NOPAYMENT.category,
    gaParams.UPDATE_PAYMENT_METHOD_SHOW_NUM_OF_ORGS_NOPAYMENT.eventType,
    msg
  );
}

export function gaNumOfOrgSelected(count) {
  gaEvent(
    gaParams.UPDATE_PAYMENT_METHOD_CLICK_NUM_OF_ORGS_CHOSEN.category,
    gaParams.UPDATE_PAYMENT_METHOD_CLICK_NUM_OF_ORGS_CHOSEN.eventType,
    count
  );
}

export function gaClickNumOfMethods(selectedPayments) {
  gaEvent(
    gaParams.UPDATE_PAYMENT_METHOD_CLICK_NUM_OF_METHOD_OPTIONS.category,
    gaParams.UPDATE_PAYMENT_METHOD_CLICK_NUM_OF_METHOD_OPTIONS.eventType,
    selectedPayments
  );
}

export function gaClickCheckBoxForSelectingPrivate(selectedPayments) {
  gaEvent(
    gaParams.UPDATE_PRIVATE_PAYMENT_CLICK_ON_CHECKBOX_PAYMENT.category,
    gaParams.UPDATE_PRIVATE_PAYMENT_CLICK_ON_CHECKBOX_PAYMENT.eventType,
    selectedPayments
  );
}

export function gaClickInfoToolTipLinkPrivate(selectedPayments) {
  gaEvent(
    gaParams.UPDATE_PRIVATE_PAYMENT_CLICK_ON_TOOLTIP_CHECKBOX_PAYMENT.category,
    gaParams.UPDATE_PRIVATE_PAYMENT_CLICK_ON_TOOLTIP_CHECKBOX_PAYMENT.eventType,
    selectedPayments
  );
}

export function gaPopupBanInfoIsOpenedPrivate(selectedPayments) {
  gaEvent(
    gaParams.UPDATE_PRIVATE_PAYMENT_POPUP_BANS_INFORMATION_IS_OPEN.category,
    gaParams.UPDATE_PRIVATE_PAYMENT_POPUP_BANS_INFORMATION_IS_OPEN.eventType,
    gaParams.UPDATE_PRIVATE_PAYMENT_POPUP_BANS_INFORMATION_IS_OPEN.eventParams
  );
}
export function gaPopupBanSelectingIsOpenedPrivate(bansCount) {
  gaEvent(
    gaParams.UPDATE_PRIVATE_PAYMENT_SELECTING_BANS_IS_OPEN.category,
    gaParams.UPDATE_PRIVATE_PAYMENT_SELECTING_BANS_IS_OPEN.eventType,
    bansCount
  );
}

export function gaPopupBanSelectingContinueButtonClickedPrivate() {
  gaEvent(
    gaParams.UPDATE_PRIVATE_PAYMENT_CLICK_OKAY_AT_POP_UP_OF_BAN_OPTIONS.category,
    gaParams.UPDATE_PRIVATE_PAYMENT_CLICK_OKAY_AT_POP_UP_OF_BAN_OPTIONS.eventType,
    gaParams.UPDATE_PRIVATE_PAYMENT_CLICK_OKAY_AT_POP_UP_OF_BAN_OPTIONS.eventParams
  );
}

export function gaFailedAndHasDebtPrivate() {
  gaEvent(
    gaParams.UPDATE_PRIVATE_PAYMENT_FAILED_UPDATES_PAGE_ACCOUNT_HAS_DEBT.category,
    gaParams.UPDATE_PRIVATE_PAYMENT_FAILED_UPDATES_PAGE_ACCOUNT_HAS_DEBT.eventType,
    gaParams.UPDATE_PRIVATE_PAYMENT_FAILED_UPDATES_PAGE_ACCOUNT_HAS_DEBT.eventParams
  );
}
export function gaFailedAndHasDebtCallBackClickPrivate() {
  gaEvent(
    gaParams.UPDATE_PRIVATE_PAYMENT_FAILED_UPDATES_PAGE_ACCOUNT_HAS_DEBT_CALLBACK_CLICK.category,
    gaParams.UPDATE_PRIVATE_PAYMENT_FAILED_UPDATES_PAGE_ACCOUNT_HAS_DEBT_CALLBACK_CLICK.eventType,
    gaParams.UPDATE_PRIVATE_PAYMENT_FAILED_UPDATES_PAGE_ACCOUNT_HAS_DEBT_CALLBACK_CLICK.eventParams
  );
}
export function gaFailedAndHasDebtTryAgainPrivate() {
  gaEvent(
    gaParams.UPDATE_PRIVATE_PAYMENT_FAILED_UPDATES_HAS_DEBT_CLICK_TRY_AGAIN.category,
    gaParams.UPDATE_PRIVATE_PAYMENT_FAILED_UPDATES_HAS_DEBT_CLICK_TRY_AGAIN.eventType,
    gaParams.UPDATE_PRIVATE_PAYMENT_FAILED_UPDATES_HAS_DEBT_CLICK_TRY_AGAIN.eventParams
  );
}
export function gaAllFailedTryAgainPrivate() {
  gaEvent(
    gaParams.UPDATE_PRIVATE_PAYMENT_ALL_FAILED_UPDATES_CLICK_TRY_AGAIN.category,
    gaParams.UPDATE_PRIVATE_PAYMENT_ALL_FAILED_UPDATES_CLICK_TRY_AGAIN.eventType,
    gaParams.UPDATE_PRIVATE_PAYMENT_ALL_FAILED_UPDATES_CLICK_TRY_AGAIN.eventParams
  );
}

export function gaAllFailedCallBackClickPrivate() {
  gaEvent(
    gaParams.UPDATE_PRIVATE_PAYMENT_ALL_FAILED_UPDATES_CALLBACK_CLICK.category,
    gaParams.UPDATE_PRIVATE_PAYMENT_ALL_FAILED_UPDATES_CALLBACK_CLICK.eventType,
    gaParams.UPDATE_PRIVATE_PAYMENT_ALL_FAILED_UPDATES_CALLBACK_CLICK.eventParams
  );
}

export function gaAllFailedPrivate() {
  gaEvent(
    gaParams.UPDATE_PRIVATE_PAYMENT_ALL_FAILED_UPDATES_PAGE.category,
    gaParams.UPDATE_PRIVATE_PAYMENT_ALL_FAILED_UPDATES_PAGE.eventType,
    gaParams.UPDATE_PRIVATE_PAYMENT_ALL_FAILED_UPDATES_PAGE.eventParams
  );
}

export function gaPartiallyFailedPrivate() {
  gaEvent(
    gaParams.UPDATE_PRIVATE_PAYMENT_PARTIALLY_OK_UPDATES_PAGE.category,
    gaParams.UPDATE_PRIVATE_PAYMENT_PARTIALLY_OK_UPDATES_PAGE.eventType,
    gaParams.UPDATE_PRIVATE_PAYMENT_PARTIALLY_OK_UPDATES_PAGE.eventParams
  );
}

export function gaPartiallyFailedCallBackClickPrivate() {
  gaEvent(
    gaParams.UPDATE_PRIVATE_PAYMENT_PARTIALLY_FAILED_UPDATES_CALLBACK_CLICK.category,
    gaParams.UPDATE_PRIVATE_PAYMENT_PARTIALLY_FAILED_UPDATES_CALLBACK_CLICK.eventType,
    gaParams.UPDATE_PRIVATE_PAYMENT_PARTIALLY_FAILED_UPDATES_CALLBACK_CLICK.eventParams
  );
}

export function gaPartiallyFailedTryAgainClickPrivate() {
  gaEvent(
    gaParams.UPDATE_PRIVATE_PAYMENT_PARTIALLY_FAILED_UPDATES_TRY_AGAIN_CLICK.category,
    gaParams.UPDATE_PRIVATE_PAYMENT_PARTIALLY_FAILED_UPDATES_TRY_AGAIN_CLICK.eventType,
    gaParams.UPDATE_PRIVATE_PAYMENT_PARTIALLY_FAILED_UPDATES_TRY_AGAIN_CLICK.eventParams
  );
}
export function gaSuccessPrivate() {
  gaEvent(
    gaParams.UPDATE_PRIVATE_PAYMENT_ALL_OK_UPDATES_PAGE.category,
    gaParams.UPDATE_PRIVATE_PAYMENT_ALL_OK_UPDATES_PAGE.eventType,
    gaParams.UPDATE_PRIVATE_PAYMENT_ALL_OK_UPDATES_PAGE.eventParams
  );
}

export function gaGeneralErrorPrivate() {
  gaEvent(
    gaParams.UPDATE_PRIVATE_PAYMENT_GENERAL_ERROR_PRIVATE.category,
    gaParams.UPDATE_PRIVATE_PAYMENT_GENERAL_ERROR_PRIVATE.eventType,
    gaParams.UPDATE_PRIVATE_PAYMENT_GENERAL_ERROR_PRIVATE.eventParams
  );
}

export function gaGeneralErrorCallBackClickPrivate() {
  gaEvent(
    gaParams.UPDATE_PRIVATE_PAYMENT_GENERAL_ERROR_CALL_BACK_CLICK_PRIVATE.category,
    gaParams.UPDATE_PRIVATE_PAYMENT_GENERAL_ERROR_CALL_BACK_CLICK_PRIVATE.eventType,
    gaParams.UPDATE_PRIVATE_PAYMENT_GENERAL_ERROR_CALL_BACK_CLICK_PRIVATE.eventParams
  );
}
